import React  from 'react';  

export const otherTaskConfig = [
  {
    auth: ['user'],
    routes: [
      {
        path: '/other-tasks/:otherTask',
        component: React.lazy(() => import('./AppOtherTask')),
      },
      {
        path: '/other-tasks/',
        component: React.lazy(() => import('./AppOtherTask')),
      },
    ],
  },
 
];